import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Card from '../../../../../components_v2/common/CardV2';
import LinkList from '../../../../../components_v2/common/LinkList';
import Listingheader from '../../common/ListingheaderV2';
import RenderAds from '../RenderAds';
import s from './Lifestyle.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder';

class Lifestyle extends React.Component {
  getItems = (sectionData, dataObj, index) => {
    const data = dataObj;
    if (data && data.items instanceof Array) {
      const gaData = sectionData.name
        ? `${sectionData.name}Section_Actions#HeadingClick-${data.name}`
        : `click-${data.name}#${data.link || data.path}`;
      return (
        <div
          className={`${s.lifestyle_wrapper} ${'col_l_4 col_m_4'}`}
          key={`ls-${index}`}
        >
          <Listingheader
            headingLink={data.link || data.path}
            headingname={data.name}
            size="small"
            newga={gaData}
            target={sectionData.target}
            ga4Type={data?.ga4Type ? data?.ga4Type : sectionData.ga4Type}
            ga4Category={
              data?.ga4Category ? data?.ga4Category : sectionData?.ga4Category
            }
          />
          <Card
            data={data.items[0]}
            isLeadTypeTwo
            showDescription={false}
            // itemClass="linktype2"
            newga={
              sectionData.name
                ? `${sectionData.name}Section_Actions#$typeClick-lead-${
                    data.name
                  }/${_get(data.items[0], 'wu', '')}`
                : `click-${data.name}-lead#${data.items[0].wu}`
            }
            imgWidth="500"
            ga4Type={data?.ga4Type ? data?.ga4Type : sectionData.ga4Type}
            ga4Category={
              data?.ga4Category ? data?.ga4Category : sectionData?.ga4Category
            }
            gaIndex={index + 1}
          />
          <div className="row">
            <LinkList
              data={data.items.slice(1)}
              className="col_l_6 bdr_right no_bdr_last linktype2"
              showDescription={false}
              //itemClass="linktype2"
              newga={
                sectionData.name
                  ? `${sectionData.name}Section_Actions#$typeClick-${
                      data.name
                    }-$index`
                  : `click-${data.name}-$index#${data.items[0].wu}`
              }
              ga4Type={data?.ga4Type ? data?.ga4Type : sectionData.ga4Type}
              ga4Category={
                data?.ga4Category ? data?.ga4Category : sectionData?.ga4Category
              }
              gaIndex={index + 1}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  /*
  getItemOrInsert = (item, inserts, index) => {
    let itemInsert = null;
    const insertPositions = [];
    inserts.forEach((insert, i) => {
      insertPositions[i] = insert.position;
    });

    const indexOfInsert = insertPositions.indexOf(index);
    if (indexOfInsert > -1) {
      const selectedInsert = inserts[indexOfInsert];
      itemInsert = (
        <RenderAds
          adObject={selectedInsert}
          adWrapperClassname="col_l_4 col_m_6 order_m_6"
        />
      );
    }
    return (
      <>
        {itemInsert}
        {this.getItems(item)}
      </>
    );
  };
  */

  render() {
    const { sectionData = {}, footer } = this.props;
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    return (
      <div className={s.wrapper} {...scrollGAAttr}>
        {sectionData.border &&
          sectionData.border === 'top' && (
            <InterSectionBorder border={sectionData.border} />
          )}
        <Listingheader
          headingname={sectionData.name}
          headingLink={sectionData.link || sectionData.path}
          newga={`${sectionData.name}Section_Actions#HeadingClick`}
          target={sectionData.target}
          ga4Type={sectionData?.ga4Type}
          ga4Category={sectionData?.ga4Category}
        />
        <div className={`${'row'}`}>
          {sectionData.items &&
            sectionData.items instanceof Array &&
            sectionData.items.map(
              (item, index) => this.getItems(sectionData, item, index),
              //this.getItemOrInsert(item, sectionData.inserts, index),
            )}
          {sectionData.inserts && sectionData.inserts.length > 0 ? (
            <div className="col_l_4 col_m_4">
              <RenderAds adObject={sectionData.inserts[0]} />
            </div>
          ) : null}
        </div>
        {React.isValidElement(footer) ? footer : ''}
      </div>
    );
  }
}

Lifestyle.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
};

export default Lifestyle;
